// extracted by mini-css-extract-plugin
export default {"badge":"SellerBadge_badge__g69hD"};